import 'css-chunksrc/client/common/horizontalList/styles.scss';export default {
  "horizontalView": "_horizontalView_w5qb2_1",
  "iconBox": "_iconBox_w5qb2_5",
  "list": "_list_w5qb2_9",
  "left": "_left_w5qb2_35",
  "right": "_right_w5qb2_40",
  "icon": "_icon_w5qb2_5"
};